// Angular Core
import { ChangeDetectorRef, Component, inject } from '@angular/core';

// Angular Material
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Rxjs
import { take } from 'rxjs/operators';

// Interfaces
import { IDialogData } from '@shared-module/interfaces';

@Component({
  selector: 'sbi-cot-back-default-confirmation-dialog',
  templateUrl: './default-confirmation-dialog.component.html',
  standalone: false,
  styleUrls: ['./default-confirmation-dialog.component.scss'],
})
export class DefaultConfirmationDialogComponent {
  private readonly _cdr = inject(ChangeDetectorRef);

  // Falls back to the data passed via MatDialog.open(Component, { data }).
  // initDialog() (used when the caller needs the loading/onConfirm flow) overrides this.
  public data: IDialogData = inject(MAT_DIALOG_DATA, { optional: true });
  public dialogRef: MatDialogRef<DefaultConfirmationDialogComponent> = inject(
    MatDialogRef,
    { optional: true }
  );
  public isLoading = false;

  public initDialog(
    data: IDialogData,
    ref: MatDialogRef<DefaultConfirmationDialogComponent>
  ): void {
    this.data = data;
    this.dialogRef = ref;
    this._cdr.detectChanges();
  }

  public onConfirmClick(): void {
    if (!this.data.onConfirm) {
      this.dialogRef?.close({ confirmed: true });
      return;
    }

    this.isLoading = true;
    this._cdr.detectChanges();

    this.data
      .onConfirm()
      .pipe(take(1))
      .subscribe({
        next: () => this.dialogRef?.close({ confirmed: true, success: true }),
        error: () => this.dialogRef?.close({ confirmed: true, success: false }),
      });
  }

  public closeDialog(): void {
    this.dialogRef?.close();
  }
}
